export default "__VITE_ASSET__DaJ5CSpg__"